import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { PendingInterceptor } from 'common/services/http-interceptor/pending-interceptor';
import * as _ from 'lodash';
import { combineLatest, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'ui-loading-bar',
  templateUrl: './loading-bar.component.html',
  styleUrls: [ './loading-bar.component.less' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingBarComponent implements OnInit {
  @Input()
  public filteredUrlPatterns: string[] = [ 'login', 'index.html' ];

  public mode: string = 'indeterminate';
  public value: number = 0;
  public showBar: boolean = false;
  public showBar$: Observable<boolean>;  // Unsubscribe is handled automatically via async pipe in template 

  constructor(
    private pendingRequestInterceptorService: PendingInterceptor,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // The loading bar should be shown until both network calls and navigation events have completed
    this.showBar$ = combineLatest([
      this.pendingRequestInterceptorService.pendingRequestsStatus,
      this.router.events
    ]).pipe(
      map(([ networkPending, routerEvent ]) => {
        // There's lots of router event types, so we just want to toggle the bar on start and end
        let navigationLoading = false;
        navigationLoading =
          routerEvent instanceof NavigationStart ? true :
            routerEvent instanceof NavigationEnd ? false :
              navigationLoading;

        return networkPending || navigationLoading;
      }),
      tap(() => this.cdr.detectChanges())
    );

    if (!(this.filteredUrlPatterns instanceof Array)) {
      throw new TypeError('`filteredUrlPatterns` must be an array.');
    }

    if (this.filteredUrlPatterns.length) {
      this.filteredUrlPatterns.forEach((e) => {
        let regExpVal = new RegExp(e);
        if (!_.find(this.pendingRequestInterceptorService.filteredUrlPatterns, (val: any) => _.isEqual(val, regExpVal))) {
          this.pendingRequestInterceptorService.filteredUrlPatterns.push(regExpVal);
        }
      });
    }
  }

}
